<app-request-form *ngIf="loginUser !== 'Zeronorth ZN'"></app-request-form>
<app-zn-requestform *ngIf="loginUser === 'Zeronorth ZN'"></app-zn-requestform>